export class RepositoryError extends Error {
    constructor(message, options) {
        super(message);
        this.name = 'RepositoryError';
        if (options?.cause !== undefined) {
            this.cause = options.cause;
        }
    }
}
